"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PreviewChip = _interopRequireDefault(require("../../chips/PreviewChip"));
var _PreviewRow = _interopRequireDefault(require("./PreviewRow.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var PreviewRow = function PreviewRow(_ref) {
  var data = _ref.data,
    prefix = _ref.prefix,
    instanceId = _ref.instanceId;
  return /*#__PURE__*/_react["default"].createElement(_PreviewRow["default"], null, prefix && /*#__PURE__*/_react["default"].createElement("span", {
    className: "preview-row-prefix"
  }, prefix), Object.keys(data).map(function (key) {
    return /*#__PURE__*/_react["default"].createElement(_PreviewChip["default"], {
      id: "".concat(instanceId).concat(data[key]),
      light: key === 'operator',
      key: "".concat(instanceId).concat(data[key])
    }, data[key] instanceof Array ? data[key].join(', ') : data[key]);
  }));
};
PreviewRow.defaultProps = {
  prefix: null
};
PreviewRow.propTypes = {
  instanceId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  data: _propTypes["default"].shape({
    variable: _propTypes["default"].string.isRequired,
    operator: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string
  }).isRequired,
  prefix: _propTypes["default"].string
};
PreviewRow.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PreviewRow",
  "props": {
    "prefix": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "instanceId": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": true
    },
    "data": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "variable": {
            "name": "string",
            "required": true
          },
          "operator": {
            "name": "string",
            "required": true
          },
          "value": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    }
  }
};
var _default = PreviewRow;
exports["default"] = _default;